module.exports = __webpack_public_path__ + "img/2-2.8da17d97.png";